import { CheckCircle2, Edit2, Trash2 } from "lucide-react";

const authUser = JSON.parse(localStorage.getItem("authUser"))?.[0];

export const initialForm = {
  id: 0,
  entityType: 0,
  portType: "0",
  cityPortName: "",
  cityPortCode: "",
  countryCode: "",
  unisoCode: "",
  scheduledCode: "",
  customerId: 0,
  portDescription: "",
  countryName: "",
  locName: "",
  createdDate: "",
  modifiedDate: "",
  activeFlag: false,
  portNotes: "",
  codeType: "",
  country: "",
  createdByUser: authUser?.firstName+" "+(authUser?.lastName || ""),
  modifiedByUser: authUser?.firstName+" "+(authUser?.lastName || ""),
  port: false,
  railTerminal: false,
  roadTerminal: false,
  airport: false,
  postalExchangeOffice: false,
  multimodalLocation: false,
  fixedTransportFunctions: false,
  inlandPort: false,
  borderCrossing: false,
};


  export const validationConfig = {
    cityPortName: { required: true, label: "Port Name" },
    scheduledCode: { required: true, label: "Schedule D/K Code" },
    countryCode: { required: true, label: "Country ISO Code" },
    unisoCode: { required: true, label: "Location (LOC Code)" },
  };

 export const filterTypeOptions = [
  {
    label: "PORT/PLACE NAME",
    value: "PORT_NAME",
  },
  {
    label: "PORT/PLACE CODE",
    value: "PORT_CODE",
  },
  {
    label: "COUNTRY",
    value: "COUNTRY",
  },
];

export const checkboxOptions = [
  { label: "Port", name: "port" },
  { label: "Rail Terminal", name: "railTerminal" },
  { label: "Road Terminal", name: "roadTerminal" },
  { label: "Air Port", name: "airport" },
  { label: "Postal Exchange Office", name: "postalExchangeOffice" },
  { label: "Multimodal Location", name: "multimodalLocation" },
  { label: "Fixed Transport Functions", name: "fixedTransportFunctions" },
  { label: "Inland Port", name: "inlandPort" },
  { label: "Border Crossing", name: "borderCrossing" },
];



  export const getPortColumns = (handlers) => {
  const { handleEdit, handleDelete } = handlers;

  return [
    {
      key: "cityPortName",
      label: "PORT/PLACE NAME",
      render: (v) => v?.cityPortName || "-"
    },
    {
      key: "cityPortCode",
      label: "PORT/PLACE CODE",
      render: (v) => v?.cityPortCode || "-"
    },
    {
      key: "country",
      label: "COUNTRY",
      render: (v) => v?.country || "-"
    },
    {
      key: "countryCode",
      label: "COUNTRY ISO CODE",
      render: (v) => v?.countryCode || "-"
    },
    {
      key: "unisoCode",
      label: "UN LOC CODE",
      render: (v) => v?.unisoCode || "-"
    },
    {
      key: "scheduledCode",
      label: "SCHEDULE D/K CODE",
      render: (v) => v?.scheduledCode || "-"
    },
    {
      key: "status",
      label: "STATUS",
      render: (v) => (
        <div
          className={`flex items-center gap-1 text-xs font-medium ${
            v?.activeFlag ? "text-green-700" : "text-red-700"
          }`}
        >
          {v?.activeFlag ? (
            <>
              <CheckCircle2 size={14} />
              Active
            </>
          ) : (
            <>
              <XCircle size={14} />
              Inactive

            </>
          )}
        </div>
      )
    },
    {
      key: "action",
      label: "ACTION",
      render: (v) => (
        <div className="flex items-center gap-3">
           <button
            onClick={() => handleEdit(v)}
                className="w-6 h-6 rounded flex items-center justify-center transition-all bg-blue-100 text-blue-700 hover:bg-blue-200 "
            title="Edit"
          >
            <Edit2 size={16} />
          </button>

          <button
            onClick={() => handleDelete(v)}
                        className="w-6 h-6 rounded flex items-center justify-center transition-all bg-red-100 text-red-700 hover:bg-red-200 "
            title="Delete"
          >
            <Trash2 size={16} />
          </button>
        </div>
      )
    }
  ];
};